// src/pages/JobFestPage.tsx

import React from "react";
import { JobFestHero } from "../sections/jobFest/JobFestHero";
import { JobFestCards } from "../sections/jobFest/JobFestCards";
import { JobFestHowItWorks } from "../sections/jobFest/JobFestHowItWorks";
import { JobFestFinalCta } from "../sections/jobFest/JobFestFinalCta";


// Make sure this file exists: src/styles/jobFest.css
import "../styles/jobFest.css";

const JobFestPage: React.FC = () => {
  return (
    <main className="jobfest-page">
      {/* Hero Section */}
      <JobFestHero />

      {/* Cards Section */}
      <JobFestCards />

      {/* How It Works */}
      <JobFestHowItWorks />

      {/* 5. Final CTA */}
      <JobFestFinalCta />

    </main>
  );
};

export default JobFestPage;
